module.exports = __webpack_public_path__ + "static/media/KVCH-OG-TAG-LOGO.d810a800.jpg";